import { Card, Divider, Stack, Typography } from "@mui/material";
import { hexStringToRgb } from "@entrilia/shared/utilities/colorHelper";
import type { FundStage } from "../../../../api/types/fundStructureTypes";

interface Props {
  name: string;
  investorsCount: number;
  stage?: FundStage;
  onClick: () => void;
}

const FundInfoCard = ({ name, investorsCount, stage, onClick }: Props) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={(theme) => ({
      maxWidth: theme.spacing(50),
      minWidth: theme.spacing(37.5),
      p: 2,
      alignSelf: "stretch",
      "&:hover": {
        "& .fund-name": {
          color: theme.palette.primary.main,
        },
        borderColor: (theme) => `rgba(${hexStringToRgb(theme.palette.primary.main).toString()}, 0.5)`,
        cursor: "pointer",
      },
    })}
  >
    <Stack spacing={1.5}>
      <Typography className="fund-name" variant="h6">
        {name}
      </Typography>
      <Divider sx={{ borderStyle: "dashed" }} />
      <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
        <Typography color="textSecondary">Stage</Typography>
        <Typography>{stage ?? ""}</Typography>
      </Stack>
      <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
        <Typography color="textSecondary">Investors</Typography>
        <Typography>{investorsCount || "-"}</Typography>
      </Stack>
    </Stack>
  </Card>
);

export default FundInfoCard;
